function PrinterSetup() {
    return (
        <div>
            <h2>Printer Setup</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default PrinterSetup;